
import { useTranslation } from 'react-i18next';

export default function InvestmentSection() {
  const { t } = useTranslation();
  
  const portfolioSectors = [
    {
      icon: 'ri-smartphone-line',
      title: t('investment.fintech.title'),
      description: t('investment.fintech.description'),
      investments: t('investment.fintech.portfolio'),
      growth: t('investment.fintech.growth')
    },
    {
      icon: 'ri-building-line',
      title: t('investment.realEstate.title'),
      description: t('investment.realEstate.description'),
      investments: t('investment.realEstate.portfolio'),
      growth: t('investment.realEstate.growth')
    },
    {
      icon: 'ri-plant-line',
      title: t('investment.agribusiness.title'),
      description: t('investment.agribusiness.description'),
      investments: t('investment.agribusiness.portfolio'),
      growth: t('investment.agribusiness.growth')
    }
  ];

  return (
    <section id="investment" className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            {t('investment.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('investment.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold mb-6">Investment Philosophy</h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              {t('investment.description')}
            </p>
            
            <div className="space-y-4">
              {(t('investment.features', { returnObjects: true }) as string[]).map((feature, index) => (
                <div key={index} className="flex items-center">
                  <i className="ri-check-line text-[#9F7B5B] mr-3 text-xl"></i>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <video
              src="/assets/invest.mp4"
              className="rounded-lg shadow-lg object-contain w-full h-[340px] bg-black"
              autoPlay
              muted
              loop
              playsInline
              controlsList="nodownload noplaybackrate nofullscreen"
              disablePictureInPicture
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {portfolioSectors.map((sector, index) => (
            <div key={index} className="bg-gray-800 rounded-xl p-6 hover:bg-gray-700 transition-colors duration-300">
              <div className="w-12 h-12 bg-[#9F7B5B] rounded-lg flex items-center justify-center mb-4">
                <i className={`${sector.icon} text-xl text-white`}></i>
              </div>
              
              <h4 className="text-xl font-bold mb-3">{sector.title}</h4>
              <p className="text-gray-300 mb-4 text-sm leading-relaxed">
                {sector.description}
              </p>
              
              <div className="flex justify-between items-center pt-4 border-t border-gray-700">
                <div>
                  <div className="text-sm text-gray-400">{t('investment.portfolio')}</div>
                  <div className="font-semibold">{sector.investments}</div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-400">{t('investment.growth')}</div>
                  <div className="font-semibold text-green-400">{sector.growth}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
